import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { deleteMspHaloIntegrationSuccess } from '../credentials/actions';
import * as actions from './actions';
import { MspHaloMapping } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspHaloMappings';

export interface State extends EntityState<MspHaloMapping>, Status {}

export const adapter = createEntityAdapter<MspHaloMapping>({
    selectId: (item) => item.tenantId,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadMspHaloMappings, (state) => ({ ...state, loading: true })),
    on(actions.loadMspHaloMappingsSuccess, (state, action) =>
        adapter.setAll(action.items, { ...state, loaded: true, loading: false }),
    ),
    on(actions.loadMspHaloMappingsFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(actions.updateMspHaloMappings, (state) => ({ ...state, updating: true })),
    on(actions.updateMspHaloMappingsSuccess, (state, action) =>
        adapter.setAll(action.items, { ...state, loaded: true, updating: false }),
    ),
    on(actions.updateMspHaloMappingsFailure, (state, { error }) => ({ ...state, error, updating: false })),
    on(deleteMspHaloIntegrationSuccess, () => initialState),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
